export const SET_PERSON_LIST = 'SET_PERSON_LIST'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_MSG_NUMBER = 'SET_MSG_NUMBER'
export const SET_TEAM_INFO = 'SET_TEAM_INFO'
